import { cn } from "@/lib/helpers/cn";

type IdentityDocumentPreviewImageProps = {
  src: string;
  onImageLoad: VoidFunction;
  isImageLoaded: boolean;
};

export function IdentityDocumentPreviewImage({
  src,
  onImageLoad,
  isImageLoaded,
}: IdentityDocumentPreviewImageProps) {
  return (
    <img
      onLoad={onImageLoad}
      className={cn(
        "tw:object-contain tw:w-auto tw:h-full",
        isImageLoaded ? "tw:block" : "tw:hidden",
      )}
      src={src}
      title="Identity Document Preview"
    />
  );
}
